module.exports = __webpack_public_path__ + "static/heart-a7d61c152cbc513b2d3bd51b64337df5.png";